document.addEventListener("DOMContentLoaded", function () {
  const loadMoreBtns = document.querySelectorAll(".load-more-btn");
  const loadLessBtns = document.querySelectorAll(".load-less-btn");
  loadMoreBtns.forEach((btn) => {
    btn.addEventListener("click", function () {
      var thisDescription = this.closest(".main_product_desc");
      const shortDescription = thisDescription
        ? thisDescription.querySelector(".short-description")
        : "";
      const fullDescription = thisDescription
        ? thisDescription.querySelector(".full-description")
        : "";
      if (shortDescription) {
        shortDescription.style.display = "none";
      }
      if (fullDescription) {
        fullDescription.style.display = "block";
      }
    });
  });
  loadLessBtns.forEach((btn) => {
    btn.addEventListener("click", function () {
      var thisDescription = this.closest(".main_product_desc");
      const shortDescription = thisDescription
        ? thisDescription.querySelector(".short-description")
        : "";
      const fullDescription = thisDescription
        ? thisDescription.querySelector(".full-description")
        : "";
      if (shortDescription) {
        shortDescription.style.display = "block";
      }
      if (fullDescription) {
        fullDescription.style.display = "none";
      }
    });
  });

  document.addEventListener("click", function (event) {
    const btn = event.target.closest(".facet_summary_btn");
    if (!btn) return;

    const containerContent = btn.nextElementSibling;

    document.querySelectorAll(".facets__content_block").forEach((content) => {
      if (content !== containerContent) {
        content.style.maxHeight = null;
        content.classList.remove("show_filters");
      }
    });

    document.querySelectorAll(".facet_summary_btn").forEach((toggle) => {
      if (toggle !== btn) {
        toggle.classList.remove("open_sort_content");
      }
    });

    btn.classList.toggle("open_sort_content");
    containerContent.classList.toggle("show_filters");

    if (containerContent.classList.contains("show_filters")) {
      containerContent.style.maxHeight = "none";
      const scrollHeight = containerContent.scrollHeight + "px";

      requestAnimationFrame(() => {
        containerContent.style.maxHeight = scrollHeight;
      });
    } else {
      containerContent.style.maxHeight = null;
    }
  });
});
//======================================
class diamondProduct extends HTMLElement {
  constructor() {
    super();
    this.collection = this.closest(".product-grid-container");
    this.ListloadMoreBtn = this.collection
      ? this.collection.querySelector(".load_more_btn")
      : null;
    this.progressBar = document.querySelector(".progress");
    this.gridLargeBtn = document.querySelector(".large_btn");
    this.gridMediumBtn = document.querySelector(".medium_btn");
    this.collectionPage = this.closest(".collection_container");
    this.nextListUrl = this.ListloadMoreBtn
      ? this.ListloadMoreBtn.getAttribute("data-next-url")
      : null;

    if (this.ListloadMoreBtn) {
      this.ListloadMoreBtn.addEventListener("click", (e) => {
        e.preventDefault();
        this.listMainLoadMoreProducts(this.nextListUrl);
      });
    }

    if (this.gridLargeBtn) {
      this.gridLargeBtn.addEventListener("click", () => {
        this.gridViewBtn();
      });
    }

    if (this.gridMediumBtn) {
      this.gridMediumBtn.addEventListener("click", () => {
        this.gridListBtn();
      });
    }

    if (this.progressBar) {
      this.progressBar.addEventListener("click", () => {
        this.ListloadMoreBtn.click();
      });
    }
  }

  gridViewBtn(event) {
    if (this.gridLargeBtn && this.collectionPage) {
      this.collectionPage.classList.add("large_grid");
      this.collectionPage.classList.remove("grid_list");
    }
  }
  gridListBtn(event) {
    if (this.gridMediumBtn && this.collectionPage) {
      this.collectionPage.classList.remove("large_grid");
      this.collectionPage.classList.add("grid_list");
    }
  }

  listMainLoadMoreProducts(nextUrl) {
    if (!nextUrl) return;
    this.ListloadMoreBtn.disabled = true;
    this.ListloadMoreBtn.classList.add("btn-loader");
    setTimeout(() => {
      this.ListloadMoreBtn.classList.remove("btn-loader");
    }, 3000);
    fetch(nextUrl)
      .then((response) => response.text())
      .then((listNextPage) => {
        const listParser = new DOMParser();
        const listHtmlDocument = listParser.parseFromString(
          listNextPage,
          "text/html"
        );
        const listNewProducts = listHtmlDocument.querySelectorAll(
          ".products_wrapper_grid_list li"
        );

        if (listNewProducts.length) {
          const productsOnListPage = document.querySelector(
            ".list_grid_main_wrapper"
          );

          listNewProducts.forEach((newProduct) => {
            productsOnListPage.appendChild(newProduct);
          });

          // this.updateProgressBar(listHtmlDocument);
          this.updateProgressBar(listNewProducts.length);


          const newLoadMoreBtn =
            listHtmlDocument.querySelector(".load_more_btn");
          this.nextListUrl = newLoadMoreBtn
            ? newLoadMoreBtn.getAttribute("data-next-url")
            : null;
          this.ListloadMoreBtn.style.display = this.nextListUrl
            ? "inline-block"
            : "none";
          this.ListloadMoreBtn.disabled = false;

          this.reinitializeSliders();
        }
      });
    // .finally(() => {
    //     this.hideLoader();
    //   });
  }
updateProgressBar(itemsAdded) {
  const loadItemsCount = document.querySelector("[load-items-count]");
  const totalProducts = parseInt(document.querySelector(".total_products").textContent, 10);

  if (loadItemsCount) {
    const currentCount = parseInt(loadItemsCount.textContent, 10);
    let newCount = currentCount + itemsAdded;

    if (newCount > totalProducts) {
      newCount = totalProducts;
    }

    loadItemsCount.textContent = newCount;

    const progressBar = document.querySelector(".bar");
    if (progressBar) {
      const progress = (newCount / totalProducts) * 100;
      progressBar.style.width = `${progress}%`;
    }

    // Optional: Hide load more button if all items are shown
    if (newCount >= totalProducts && this.ListloadMoreBtn) {
      this.ListloadMoreBtn.style.display = "none";
    }
  }
}

  // updateProgressBar(listHtmlDocument) {
  //   const loadItemsCount = document.querySelector("[load-items-count]");
  //   const totalProducts = document.querySelector(".total_products").textContent;

  //   if (loadItemsCount) {
  //     const currentCount = parseInt(loadItemsCount.textContent, 10);
  //     const newCount =
  //       currentCount + listHtmlDocument.querySelectorAll(".grid__item").length;
  //     loadItemsCount.textContent = newCount;

  //     const progressBar = document.querySelector(".bar");
  //     if (progressBar) {
  //       const progress = (newCount / parseInt(totalProducts, 10)) * 100;
  //       progressBar.style.width = `${progress}%`;
  //     }
  //   }
  // }

  reinitializeSliders() {
    setTimeout(() => {
      const myCustomSlider = document.querySelectorAll(".slide_imgs-swiper");
      if (myCustomSlider) {
        myCustomSlider?.forEach((myCustomSliderItem) => {
          var slider = new Swiper(myCustomSliderItem, {
            loop: true,
            spaceBetween: 3,
            initialSlide: 0,
            // direction: "rtl",
            breakpoints: {
              990: {
                spaceBetween: 5,
                loop: true,
                initialSlide: 0,
              },
            },
            //                      pagination: {
            // 	el: ".swiper-pagination",
            // 	clickable: true
            // },
            pagination: {
              el: ".swiper-pagination",
              clickable: true,
              renderBullet: function (index, className) {
                const totalSlides = this.slides.length; // Total number of slides
                const maxBullets = Math.min(4, totalSlides); // Maximum bullets to be shown (4 or less)

                // If total slides are more than 4, limit bullet display
                if (totalSlides > 4) {
                  // Show only 4 bullets at most
                  if (index < 4) {
                    return `<span class="${className}"></span>`;
                  }
                  return ""; // Hide extra bullets
                } else {
                  return `<span class="${className}"></span>`;
                }
              },
            },
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
            scrollbar: {
              el: ".swiper-scrollbar",
              hide: true,
            },
          });
        });
      }
    }, 100);
  }
}

customElements.define("diamond-product", diamondProduct);
